import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { ApplicationDispatch, SET_SERVER_MESSAGE } from '../store/application/types';
import { fetchData } from './fetch';

export const queryReports = async (dispatch: ApplicationDispatch) => {
  try {
    const url = `api/reporting`;
    const reports = (await fetchData(url, dispatch)) as LosReports;
    return reports;
  } catch (error: any) {
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: error },
    });
    throw error;
  }
};

export const useQueryReports = () => {
  const dispatch = useDispatch<ApplicationDispatch>();
  return useQuery(['reports'], async () => await queryReports(dispatch), {
    refetchOnWindowFocus: false,
  });
};

export interface LosReport {
  clientReportId: number;
  clientId: string;
  categoryName: string;
  moduleName: string;
  reportName: string;
  reportId: string;
  reportDescription: string;
  reportImageLocation: string;
  defaultTabId: string;
}

export interface LosReports {
  flat: LosReport[];
  grouped: [
    {
      categoryName: string;
      modules: [
        {
          moduleName: string;
          reports: LosReport[];
        }
      ];
    }
  ];
}
